module.exports = __webpack_public_path__ + "static/logistics-cust-booking-7cc0198ad021908820d68d13cc648efc.png";